import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { StickyContainer } from '@sparefoot/react-core';

import { withSearchHandler } from 'decorators';
import { Section, Container, Row, Column, Paragraph } from 'components/atoms';
import { SearchBox } from 'components/molecules';

import MapPin from 'components/svg/MapPin';

import './StickySearch.scss';

export const enhance = compose(withRouter, withSearchHandler);

export const StickySearch = ({ triggerId, handleSearch }) => {
	return (
		<StickyContainer triggerId={triggerId}>
			<Section className="sticky-search-bar">
				<Container>
					<Row>
						<Column>
							<div className="sticky-search">
								<Paragraph
									weight="extraBold"
									color="white"
									size="mediumLarge"
								>
									Find Storage Units Near You
								</Paragraph>
								<SearchBox
									inputLabel="Enter Zip Code or City Name"
									onSearch={handleSearch}
									icon={<MapPin fill="gray" />}
									withSearchType={false}
									hideAutocompleteOnScroll
									useBrowserLocation
								/>
							</div>
						</Column>
					</Row>
				</Container>
			</Section>
		</StickyContainer>
	);
};

StickySearch.propTypes = {
	handleSearch: PropTypes.func.isRequired,
	triggerId: PropTypes.string,
};

export default enhance(StickySearch);
